"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var avatars_1 = require("./avatars");
var ProfileGate_less_1 = __importDefault(require("./ProfileGate.less"));
var ProfileAvatar = function (_a) {
    var profile = _a.profile, className = _a.className;
    var dicebear = (0, avatars_1.parseAvatar)(profile.avatar);
    if (dicebear !== null) {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, ProfileGate_less_1.default['avatar']) },
            react_1.default.createElement("img", { className: ProfileGate_less_1.default['avatar-image'], src: (0, avatars_1.avatarUrl)(dicebear.style, dicebear.seed), alt: '', draggable: false })));
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, ProfileGate_less_1.default['avatar'], ProfileGate_less_1.default['avatar-letter']), style: { backgroundColor: (0, avatars_1.legacyAvatarColor)(profile.avatar) } }, profile.name.trim().charAt(0).toUpperCase()));
};
exports.default = ProfileAvatar;
